module.exports = __webpack_public_path__ + "img/layout-right.483d4ee7.svg";